
import { graphql, PageProps, useStaticQuery } from "gatsby"
import { IMissionSection, IHistorySection, IAboutUsSection, IEventsSection, ITimelineSection, IManagmentSection, IAdressDataSection, ILawInformationsSection, IContactAccountsSection, IPostsSection, IPressInformationsSpecialistSection, IDownloadableAssetsSection } from "interfaces/sections"
import { Brand, Csr, Information, Person, Post } from "types"
import Footer from "types/footer"
import OpenGraph from "types/opengraph"
import { StringMappingType } from "typescript"
import Media from "../types/media"


const useFooter = (): Footer[] => {
  const { allWpFooter } = useStaticQuery(graphql`
  query {
    allWpFooter(sort: { date: DESC } ) {
      nodes {
        footeroptions{
          leftcolumn: footerleftcolumn
          rightcolumn: footerrightcolumn
          image: footerimage {
            mediaItemUrl
            mimeType
            mediaType
            altText
            title
            gatsbyImage: localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
            }
          }
        }
      }
  }}`)
  return allWpFooter.nodes[0]


}

export default useFooter